/** Picks v2 or v1 of the App Users Lookup page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AppUserPage   from './AppUserPage';
import AppUserPageV2 from './v2/AppUserPageV2';

export default function AppUserPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AppUserPageV2 : AppUserPage;
  return <Component {...props} />;
}
